module.exports = __webpack_public_path__ + "static/roman-schiefer.8039127a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/roman-schiefer.jpg
// module id = 675
// module chunks = 168707334958949